import { RichTextField } from '@prismicio/types'

export interface PrismicTakeBack {
  id: string
  uid: any
  url: any
  type: string
  href: string
  tags: any[]
  first_publication_date: string
  last_publication_date: string
  slugs: string[]
  linked_documents: any[]
  lang: string
  alternate_languages: AlternateLanguage[]
  data: PrismicTakeBackData
}

export interface AlternateLanguage {
  id: string
  type: string
  lang: string
}

export interface PrismicTakeBackData {
  take_back_main_title: TakeBackMainTitle[]
  take_back_text: TakeBackText[]
  required_field: RequiredField[]
  take_back_title_step_1: TakeBackTitleStep1[]
  take_back_title_step_2: TakeBackTitleStep2[]
  take_back_title_step_3: TakeBackTitleStep3[]
  previous_step: PreviousStep[]
  meta_title_take_back: MetaTitleTakeBack[]
  meta_description_take_back: MetaDescriptionTakeBack[]
  meta_keywords_take_back: any[]
  question_title: QuestionTitle[]
  questions: Question[]
  error_message: ErrorMessage[]
  item: Item[]
  reference_number_title: ReferenceNumberTitle[]
  reference_number_placeholder: ReferenceNumberPlaceholder[]
  reference_number_explication_link: ReferenceNumberExplicationLink[]
  reference_number_explication_title: ReferenceNumberExplicationTitle[]
  reference_number_explication_text: ReferenceNumberExplicationText[]
  reference_check_button: ReferenceCheckButton[]
  reference_error: ReferenceError[]
  perfectcondition: Perfectcondition[]
  perfectconditiondefinition: Perfectconditiondefinition[]
  verygoodcondition: Verygoodcondition[]
  verygoodconditiondefinition: Verygoodconditiondefinition[]
  goodcondition: Goodcondition[]
  goodconditiondefinition: Goodconditiondefinition[]
  refusedcondition: Refusedcondition[]
  refusedconditiondefinition: Refusedconditiondefinition[]
  next_step_button: NextStepButton[]
  select_size_label: SelectSizeLabel[]
  select_state_label: SelectStateLabel[]
  select_size_placeholder: SelectSizePlaceholder[]
  select_state_placeholder: SelectStatePlaceholder[]
  states_explanation_link: StatesExplanationLink[]
  waiting_price_text: WaitingPriceText[]
  offer_announcement_text: OfferAnnouncementText[]
  price_explication: PriceExplication[]
  accept_offer_button: AcceptOfferButton[]
  subtitle: Subtitle[]
  register_text: RegisterText[]
  add_product_button: AddProductButton[]
  reference: Reference[]
  total_price: TotalPrice[]
  take_back_location_title: TakeBackLocationTitle[]
  take_back_location_explanation: TakeBackLocationExplanation[]
  take_back_locations: TakeBackLocation[]
  text_cgu: TextCgu[]
  text_confirmation: TextConfirmation[]
  confirmation_title: ConfirmationTitle[]
  your_order_number: YourOrderNumber[]
  confirmation_text: ConfirmationText[]
  voucher_printing_button: VoucherPrintingButton[]
  shop_link_text: ShopLinkText[]
  body: Body[]
  faq_title: FaqTitle[]
  find_product_without_reference: boolean
  display_faq_on_page: boolean
  close_others_on_click: boolean
  q_a: QA[]
  price_text_shop_page: PriceTextShopPage[]
  second_hand_label: SecondHandLabel[]
  price_start: any[]
  original_price: OriginalPrice[]
  state_label: StateLabel[]
  tab_label_secondhand: any[]
  tab_label_rental: any[]
  take_back_description: TakeBackDescription[]
  prevent_adding_differents_types_to_cart: any[]
  take_back_list_title: TakeBackListTitle[]
  status_label: StatusLabel[]
  accepted_status: Status[]
  refused_status: Status2[]
  in_progress_status: Status3[]
  command: Command[]
  order_withdrawal_text: OrderWithdrawalText[]
  take_back_estimated_price: any[]
  order_second_hand_details: any[]
  product_returned: any[]
  take_back_stock_alert_enable: boolean
  take_back_stock_alert_text: any
  take_back_stock_alert_link: any
  take_back_stock_alert_modal_title: any
  take_back_stock_alert_modal_text: any
  take_back_stock_alert_modal_size_label: any
  is_take_back_activated: boolean
  disable_good_condition: boolean
  take_back_location_verification_enabled: boolean
  text_location_verification_title: TextLocationVerificationTitle[]
  text_confirm_location_button: TextConfirmLocationButton[]
  show_confirmation: boolean
  first_confirmation_title: string
  first_confirmation_body: RichTextField
  first_confirmation_button_label: RichTextField
  second_confirmation_title: string
  second_confirmation_body_perfect_condition: RichTextField
  second_confirmation_body_very_good_condition: RichTextField
  second_confirmation_body_good_condition: RichTextField
  second_confirmation_button_label: RichTextField
  show_edit_parcel_number: boolean
  show_voucher_printing_button: boolean
  second_hand_description_position: SecondHandDescriptionPosition
}

export enum SecondHandDescriptionPosition {
  BelowProductDescription = 'below_product_description',
  BelowQualitySelector = 'below_quality_selector',
}

export interface TakeBackMainTitle {
  type: string
  text: string
  spans: any[]
}

export interface TakeBackText {
  type: string
  text: string
  spans: any[]
}

export interface RequiredField {
  type: string
  text: string
  spans: any[]
}

export interface TakeBackTitleStep1 {
  type: string
  text: string
  spans: any[]
}

export interface TakeBackTitleStep2 {
  type: string
  text: string
  spans: any[]
}

export interface TakeBackTitleStep3 {
  type: string
  text: string
  spans: any[]
}

export interface PreviousStep {
  type: string
  text: string
  spans: any[]
}

export interface MetaTitleTakeBack {
  type: string
  text: string
  spans: any[]
}

export interface MetaDescriptionTakeBack {
  type: string
  text: string
  spans: any[]
}

export interface QuestionTitle {
  type: string
  text: string
  spans: any[]
}

export interface Question {
  question: Question2[]
  is_required: boolean
}

export interface Question2 {
  type: string
  text: string
  spans: any[]
}

export interface ErrorMessage {
  type: string
  text: string
  spans: Span[]
}

export interface Span {
  start: number
  end: number
  type: string
}

export interface Item {
  type: string
  text: string
  spans: any[]
}

export interface ReferenceNumberTitle {
  type: string
  text: string
  spans: Span2[]
}

export interface Span2 {
  start: number
  end: number
  type: string
}

export interface ReferenceNumberPlaceholder {
  type: string
  text: string
  spans: any[]
}

export interface ReferenceNumberExplicationLink {
  type: string
  text: string
  spans: Span3[]
}

export interface Span3 {
  start: number
  end: number
  type: string
}

export interface ReferenceNumberExplicationTitle {
  type: string
  text: string
  spans: Span4[]
}

export interface Span4 {
  start: number
  end: number
  type: string
}

export interface ReferenceNumberExplicationText {
  type: string
  url?: string
  alt: any
  copyright: any
  dimensions?: Dimensions
  id?: string
  edit?: Edit
  text?: string
  spans?: Span5[]
}

export interface Dimensions {
  width: number
  height: number
}

export interface Edit {
  x: number
  y: number
  zoom: number
  background: string
}

export interface Span5 {
  start: number
  end: number
  type: string
}

export interface ReferenceCheckButton {
  type: string
  text: string
  spans: any[]
}

export interface ReferenceError {
  type: string
  text: string
  spans: Span6[]
}

export interface Span6 {
  start: number
  end: number
  type: string
}

export interface Perfectcondition {
  type: string
  text: string
  spans: any[]
}

export interface Perfectconditiondefinition {
  type: string
  text: string
  spans: any[]
}

export interface Verygoodcondition {
  type: string
  text: string
  spans: any[]
}

export interface Verygoodconditiondefinition {
  type: string
  text: string
  spans: any[]
}

export interface Goodcondition {
  type: string
  text: string
  spans: any[]
}

export interface Goodconditiondefinition {
  type: string
  text: string
  spans: any[]
}

export interface Refusedcondition {
  type: string
  text: string
  spans: any[]
}

export interface Refusedconditiondefinition {
  type: string
  text: string
  spans: any[]
}

export interface NextStepButton {
  type: string
  text: string
  spans: any[]
}

export interface SelectSizeLabel {
  type: string
  text: string
  spans: any[]
}

export interface SelectStateLabel {
  type: string
  text: string
  spans: any[]
}

export interface SelectSizePlaceholder {
  type: string
  text: string
  spans: any[]
}

export interface SelectStatePlaceholder {
  type: string
  text: string
  spans: any[]
}

export interface StatesExplanationLink {
  type: string
  text: string
  spans: any[]
}

export interface WaitingPriceText {
  type: string
  text: string
  spans: any[]
}

export interface OfferAnnouncementText {
  type: string
  text: string
  spans: any[]
}

export interface PriceExplication {
  type: string
  text: string
  spans: any[]
}

export interface AcceptOfferButton {
  type: string
  text: string
  spans: any[]
}

export interface Subtitle {
  type: string
  text: string
  spans: any[]
}

export interface RegisterText {
  type: string
  text: string
  spans: any[]
}

export interface AddProductButton {
  type: string
  text: string
  spans: any[]
}

export interface Reference {
  type: string
  text: string
  spans: any[]
}

export interface TotalPrice {
  type: string
  text: string
  spans: any[]
}

export interface TakeBackLocationTitle {
  type: string
  text: string
  spans: any[]
}

export interface TakeBackLocationExplanation {
  type: string
  text: string
  spans: Span7[]
}

export interface Span7 {
  start: number
  end: number
  type: string
}

export interface TakeBackLocation {
  take_back_location: TakeBackLocation2[]
  incentive?: number
  location_api_key: LocationApiKey[]
  enable_take_back_country: boolean
  take_back_country_title: TakeBackCountryTitle[]
  only_available_for: OnlyAvailableFor[]
}

export interface TakeBackLocation2 {
  type: string
  text: string
  spans: Span8[]
}

export interface OnlyAvailableFor {
  type: string
  text: string
  spans: Span8[]
}

export interface TakeBackCountryTitle {
  type: string
  text: string
  spans: Span8[]
}

export interface Span8 {
  start: number
  end: number
  type: string
  data?: Data2
}

export interface Data2 {
  link_type: string
  url: string
  target: string
}

export interface LocationApiKey {
  type: string
  text: string
  spans: any[]
}

export interface TextCgu {
  type: string
  text: string
  spans: any[]
}

export interface TextConfirmation {
  type: string
  text: string
  spans: any[]
}

export interface ConfirmationTitle {
  type: string
  text: string
  spans: any[]
}

export interface YourOrderNumber {
  type: string
  text: string
  spans: any[]
}

export interface ConfirmationText {
  type: string
  text: string
  spans: Span9[]
}

export interface Span9 {
  start: number
  end: number
  type: string
}

export interface VoucherPrintingButton {
  type: string
  text: string
  spans: any[]
}

export interface ShopLinkText {
  type: string
  text: string
  spans: any[]
}

export interface Body {
  primary: Primary
  items: Item2[]
  id: string
  slice_type: string
  slice_label: any
}

export interface Primary {
  text_align: string
}

export interface Item2 {
  title: Title[]
  text: Text[]
}

export interface Title {
  type: string
  text: string
  spans: any[]
}

export interface Text {
  type: string
  text: string
  spans: Span10[]
}

export interface Span10 {
  start: number
  end: number
  type: string
  data?: Data3
}

export interface Data3 {
  link_type: string
  url: string
  target: string
}

export interface FaqTitle {
  type: string
  text: string
  spans: any[]
}

export interface QA {
  question: Question3[]
  answer: Answer[]
}

export interface Question3 {
  type: string
  text: string
  spans: Span11[]
}

export interface Span11 {
  start: number
  end: number
  type: string
}

export interface Answer {
  type: string
  text: string
  spans: Span12[]
}

export interface Span12 {
  start: number
  end: number
  type: string
}

export interface PriceTextShopPage {
  type: string
  text: string
  spans: any[]
}

export interface SecondHandLabel {
  type: string
  text: string
  spans: any[]
}

export interface OriginalPrice {
  type: string
  text: string
  spans: any[]
}

export interface StateLabel {
  type: string
  text: string
  spans: any[]
}

export interface TakeBackDescription {
  type: string
  text: string
  spans: any[]
}

export interface TakeBackListTitle {
  type: string
  text: string
  spans: any[]
}

export interface StatusLabel {
  type: string
  text: string
  spans: any[]
}

export interface Status {
  type: string
  text: string
  spans: any[]
}

export interface Status2 {
  type: string
  text: string
  spans: any[]
}

export interface Status3 {
  type: string
  text: string
  spans: any[]
}

export interface Command {
  type: string
  text: string
  spans: any[]
}

export interface OrderWithdrawalText {
  type: string
  text: string
  spans: any[]
}

export interface TextLocationVerificationTitle {
  type: string
  text: string
  spans: any[]
}

export interface TextConfirmLocationButton {
  type: string
  text: string
  spans: any[]
}
